module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "steps bg-darkest lightest text-center"
  }, [_c('ul', {
    staticClass: "d-flex align-items-center"
  }, _vm._l((_vm.steps), function(step) {
    return _c('li', {
      staticClass: "d-flex align-items-center lightest p-3 m-2",
      class: {
        active: (step.number === _vm.currentStep),
        pointer: _vm.editing
      },
      on: {
        "click": function($event) {
          return _vm.switchStep($event, step)
        }
      }
    }, [_c('span', {
      staticClass: "number radius-circle"
    }, [_vm._v(_vm._s(step.number))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(step.label))])])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-19815c4a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19815c4a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductSteps.vue
// module id = 1532
// module chunks = 0